import React, { useContext, useEffect, useState } from 'react';
import ArticleCarousel from 'LandingPage/components/ArticleCarousel/ArticleCarousel';
import { Heading } from 'LandingPage/style/CommonStyles';
import {
	ArticlesWrapper,
	HeadingWrapper,
	LoadingContainer,
	SectionWrapper,
} from './SectionTwo.styles';
import { getIndustryArticles, getVendorArticles } from 'utils/apiRequests';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { SettingsContext } from 'contexts/SettingsContext';

const getFormattedArray = data => {
	const result = [];
	const { industries, vendor } = data;
	const maxItems = Math.max(industries.length, vendor.length);

	for (let i = 0; i < maxItems; i += 3) {
		industries.slice(i, i + 3).forEach(item => {
			result.push({
				title: item.title,
				titleLimited: item.title,
				descriptionLimited:
					item.description.length > 100
						? item.description.substring(0, 135) + '...'
						: item.description,
				url: item.url,
				tag: 'Industry',
			});
		});

		vendor.slice(i, i + 3).forEach(item => {
			result.push({
				title: item.title,
				titleLimited: item.title,
				descriptionLimited:
					item.description.length > 100
						? item.description.substring(0, 135) + '...'
						: item.description,
				url: item.url,
				tag: 'Vendor',
			});
		});
	}

	return result;
};

const SectionTwo = () => {
	const [articles, setArticles] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const { companiesMetadata } = useContext(SettingsContext);
	const industryList = companiesMetadata?.companies
		?.map(x => {
			return Number(x?.industry?.data?.key);
		})
		.filter(x => x);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [
					industryArticleResponse,
					vendorArticleResponse,
				] = await Promise.all([
					getIndustryArticles({ industryKey: industryList }),
					getVendorArticles(),
				]);
				if (
					industryArticleResponse.data !== null &&
					vendorArticleResponse.data !== null
				) {
					if (
						industryArticleResponse.data.length > 0 ||
						vendorArticleResponse.data.length > 0
					) {
						const newData = {
							industries:
								industryArticleResponse.data.length > 0
									? industryArticleResponse.data
									: [],
							vendor:
								vendorArticleResponse.data.length > 0
									? vendorArticleResponse.data
									: [],
						};
						setArticles(getFormattedArray(newData));
					}
				}
			} catch (err) {
				console.error('Error fetching data:', err);
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();
	}, []);

	const Loader = () => (
		<LoadingContainer>
			<ApLoaderDefault loaderText={() => <ApLoaderText />} />
		</LoadingContainer>
	);

	return (
		<SectionWrapper>
			<HeadingWrapper>
				<Heading>Industry & Vendor Insights</Heading>
			</HeadingWrapper>
			<ArticlesWrapper>
				{isLoading ? <Loader /> : <ArticleCarousel articles={articles} />}
			</ArticlesWrapper>
		</SectionWrapper>
	);
};

export default SectionTwo;
